import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CompanyDashboardComponent } from 'components/company/company-dashboard.component';
import { ButtonComponent } from 'components/input/button/button.component';
import { CredentialType } from 'enums/CredentialType';
import { CompanyQueryModel } from 'models/generated/Models.CompanyQuery';
import { CompanySearchResultViewModel } from 'models/generated/Models.CompanySearchResultView';
import { Inputs } from 'modules/inputs';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyService } from 'services/company.service';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';

@Component({
	selector: 'test-searchcompany',
	templateUrl: './test-searchcompany.component.html',
	imports: [Layout, Inputs, FormsModule, TranslatePipe]
})
@ComponentUrl('searchcompany')
@CredentialRequired(CredentialType.BetaUserAccess)
export class TestSearchCompanyComponent {

	@ViewChild('searchButton') searchButton?: ButtonComponent;
	companyQuery = new CompanyQueryModel();
	result?: CompanySearchResultViewModel[];

	constructor(private readonly companyService: CompanyService, private readonly navigate: NavigationService) {
		this.companyQuery.zipCode = [''];
	}

	async searchCompany() {
		this.result = await this.companyService.searchCompany(this.companyQuery);
		this.searchButton?.reset();
	}
	async viewCompany(company: CompanySearchResultViewModel) {
		const view = await this.navigate.refreshView(CompanyDashboardComponent);
		view.companyId = company.companyId!;
	}
}
